import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { marked } from 'marked';

import { convertMarkdownToPlainText } from '@eluve/utils';

export const ClipboardExtension = Extension.create({
  name: 'clipboard',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('clipboard'),
        props: {
          handleDOMEvents: {
            copy: (view, event) => {
              try {
                const { state } = view;
                const { from, to } = state.selection;

                // If nothing is selected, let default behavior handle it
                if (from === to) {
                  return false;
                }

                // Get the selected slice and convert it to markdown directly
                const slice = state.doc.slice(from, to);
                const tempDoc = state.schema.nodeFromJSON({
                  type: 'doc',
                  content: slice.content.toJSON(),
                });

                // Access editor instance from the plugin context
                const editor = (this as any).editor;

                // Get markdown from the temp doc using the markdown serializer directly
                const markdown =
                  editor?.storage.markdown?.serializer.serialize(tempDoc) ?? '';

                // Use the same logic as useCopyContentElement
                const htmlContent = marked(markdown);
                const plainText = convertMarkdownToPlainText(markdown);

                // Set clipboard data with both HTML and plain text
                if (typeof ClipboardItem !== 'undefined') {
                  const html = new Blob([htmlContent], { type: 'text/html' });
                  const text = new Blob([plainText], { type: 'text/plain' });
                  const data = new ClipboardItem({
                    'text/html': html,
                    'text/plain': text,
                  });

                  // Handle async clipboard write with error handling
                  navigator.clipboard.write([data]).catch((_err) => {
                    // Fallback to older method if modern clipboard API fails
                    event.clipboardData?.setData('text/html', htmlContent);
                    event.clipboardData?.setData('text/plain', plainText);
                  });
                } else {
                  // Fallback for older browsers
                  event.clipboardData?.setData('text/html', htmlContent);
                  event.clipboardData?.setData('text/plain', plainText);
                }

                // Prevent default copy behavior
                event.preventDefault();
                return true;
              } catch (_err) {
                // Silent fallback - clipboard operations are not critical to app functionality
                return false;
              }
            },
          },
        },
      }),
    ];
  },
});
